@if (showSplash()) {
<app-sequal-splash (animationComplete)="onSplashDone()" />
}
<ion-app>
  <!-- Side Menu -->
  @if (!isComingSoon) {
  <div>
    <app-menu></app-menu>
    <!-- Main Content -->
    <div class="ion-page" id="main-content">
      <!-- Render Routes -->
      <ion-content>
        <ion-router-outlet></ion-router-outlet>
      </ion-content>
      <app-email-gate></app-email-gate>
      <!-- Headless: presents the first-run welcome carousel. Mounting is the
           trigger, so it waits for the splash to finish — never two first-run
           surfaces at once. -->
      @if (!showSplash()) {
        <app-onboarding-host></app-onboarding-host>
      }
      @if (panelOpen()) {
        <app-workout-command-center
          [minimized]="panelMinimized()"
          (closePanel)="onClosePanel()"
          (minimizePanel)="onMinimizePanel()"
          (reopenPanel)="reopenPanel()"
        ></app-workout-command-center>
      }
    </div>
  </div>
  } @if (isComingSoon) {
  <app-coming-soon></app-coming-soon>
  }
  <!-- Headless: drives the global Pro paywall modal + pro-intent resume. -->
  <app-paywall-host></app-paywall-host>
</ion-app>
<!-- Guided-tour spotlight. Outside ion-app so it can dim the side menu and the
     tab bar alike; it renders nothing until a tour is running. -->
<app-tour-overlay></app-tour-overlay>
